import React from 'react';
import { useAuth } from '../../authentication/hooks/useAuth';

interface Props {
  readonly role?: string | string[];
  readonly cant?: () => React.ReactNode;
  readonly children: React.ReactNode;
}

export const CanByRole = (p: Props) => {
  const auth = useAuth();

  if (!auth || !auth.user) {
    throw new Error('Auth context or user not found');
  }

  if (p.role) {
    const allowedRoles = Array.isArray(p.role) ? p.role : [p.role];

    if (!allowedRoles.includes(auth.user.role)) {
      return p.cant!() as any;
    }
  }

  return p.children;
};

CanByRole.defaultProps = {
  cant: () => null,
};
